import { render, staticRenderFns } from "./2018.vue?vue&type=template&id=3fac316b&"
import script from "./2018.vue?vue&type=script&lang=js&"
export * from "./2018.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports